import React, { memo } from 'react'

import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

const labels = {
  [MATERIAL.PBR]: 'PBR',
  [MATERIAL.BASIC]: 'Basic',
  [MATERIAL.GEOMETRY_ONLY]: 'Geometry',
}

function CollapsedMaterialRow() {
  const material = useThreeDStudioStore(state => state.modelSettings.material)
  const buttonLabel = labels[material] || ''
  const isActive = Boolean(buttonLabel)

  return (
    <ClosedButtonSettings
      label="Material"
      isActive={isActive}
      buttonLabel={buttonLabel}
    />
  )
}

export default memo(CollapsedMaterialRow)
